/**
 * VistoeraTASK-00609 — detect when a blocking editor Modal/overlay owns
 * interaction (image editor, other vst-modal-surface surfaces). Used to
 * gate Canvas React Flow Delete/Backspace and node context menus so they
 * cannot fire "through" a transparent-mask Modal.
 */

/** Canvas Image Editor Modal test id (CanvasImageEditorOverlay). */
export const CANVAS_IMAGE_EDITOR_MODAL_TESTID = 'canvas-image-editor-modal'

/**
 * True when an antd Modal wrap or Vistoera modal surface is visible.
 * Prefer the image-editor test id; fall back to any open ant-modal-wrap /
 * `.vst-modal-surface` so other full-screen editors are also gated.
 */
export function isCanvasBlockingOverlayOpen(doc: Document = document): boolean {
  if (typeof doc === 'undefined' || !doc.querySelector) return false
  if (doc.querySelector(`[data-testid="${CANVAS_IMAGE_EDITOR_MODAL_TESTID}"]`)) return true
  if (doc.querySelector('.ant-modal-wrap:not(.ant-modal-wrap-hidden)')) return true
  if (doc.querySelector('.vst-modal-surface')) return true
  return false
}
